import Phaser from 'phaser';
import { PreloadScene } from '../scenes/PreloadScene';
import { BootScene } from '../scenes/BootScene';
import { SceneRunner } from '../scenes/SceneRunner';

// The Game (World host). WebGL is required — the Rig renders through Mesh2D,
// which is WebGL-only.
//
// There is no physics plugin. Arcade Physics resolves screen-space AABBs, which
// is the wrong space for a belt-scroll: "up" is depth, not height. physics/belt.ts
// integrates (x, z, h) by hand instead — direct velocity, one gravity axis, no
// solver — which is the same deterministic spine, just in the right coordinates.

export const VIEW_WIDTH = 640;
export const VIEW_HEIGHT = 360;

export function createGame(): Phaser.Game {
  return new Phaser.Game({
    type: Phaser.WEBGL,
    parent: 'game',
    width: VIEW_WIDTH,
    height: VIEW_HEIGHT,
    backgroundColor: '#0a0a0c',
    pixelArt: false,
    roundPixels: true,
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    input: {
      gamepad: true,
    },
    scene: [PreloadScene, BootScene, SceneRunner],
  });
}
